<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-form
        :inline="true"
        :model="searchForm"
        :rules="searchRules"
        ref="searchForRef"
        label-width="80px"
        autocomplete="on"
        size="mini"
      >
      <el-row :gutter="24">
        <el-col :span="24">

            <el-form-item prop="name">
              <el-input v-model="searchForm.name" clearable type="text"></el-input>
            </el-form-item>

          <el-form-item>
            <el-button type="success"  @click="searchSubmit()">搜索</el-button>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary">
              <i class="el-icon-plus"></i>增加金豆
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        height="450"
        stripe
        border
        size="mini"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          label="用户ID"
          width="80"
          prop="user_id"
        >
        </el-table-column>
        <el-table-column
          label="姓名"
          width="120"
          prop="realname"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="昵称"
          width="120"
          prop="nickname"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="用户名"
          width="120"
          prop="user_name"
        >
        </el-table-column>
        <el-table-column
          label="余额"
          width="100"
          prop="user_money"
        >
        </el-table-column>
        <el-table-column
          label="金豆数"
          width="100"
          prop="bean_num"
        >
        </el-table-column>

        <el-table-column
          label="注册日期"
          width="160"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.reg_time | dateFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="180">
          <template slot-scope="scope">
            <el-button @click="goEdit(scope.row)"  type="text" size="mini">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->


    <eUserForm
      :formData="formData"
      :visible.sync="visible"
      :title="title"
      :closeForm="closeForm"
    />
  </div>
</template>

<script>
  import eUserForm from "../common/eUserForm.vue";
  import moment from 'moment'     //日期时间转换

  export default {
    name: "userList",
    components: {
      eUserForm
    },
    props: {},
    data() {
      return {
        formData:{},
        title:'',
        visible:false,
        // 搜索
        searchForm: {
          name: "",
        },
        searchRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        form: {
          name: '',
        },

      };
    },
    created() {
      this.DataList()

    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },


    },
    methods: {
      closeForm(){
        this.title="";
        this.visible=false;
      },
      goEdit(row){
        this.title="编辑用户";
        this.formData.realname=row.realname;
        this.formData.nickname=row.nickname;
        this.formData.user_id=row.user_id;
        this.formData.user_name=row.user_name;
        this.formData.parent_id=row.parent_id;
        this.formData.parent_name=row.parent?row.parent.realname:'';
        this.visible=true;
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        if(this.searchForm.name){
          param.keyword=this.searchForm.name;
        }
        this.$axios.userList(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        // this.title = '新增'
        // this.form = {
        //   name: '',
        // }
        // this.dialogFormVisible = true
        this.$router.push('/newsForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
       this.pageNum=1;
       this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
